import { useTranslation } from "@msuite/ui/localization";

/** Props Interface */
interface DefaultApproverNamesProps {
	/** The set's workspace, or null for the organisation's. */
	workspaceId: string | null;
	approverNames: string[];
}

export function DefaultApproverNames({ workspaceId, approverNames }: DefaultApproverNamesProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	if (approverNames.length) return <p>{approverNames.join(", ")}</p>;
	// An empty set is a rule rather than a gap, so the cell names who approves instead.
	return (
		<p className="label">
			{workspaceId
				? t("incoming_invoices.falls_back_to_organization_approvers")
				: t("incoming_invoices.falls_back_to_owner")}
		</p>
	);
}
